export default __webpack_public_path__ + "static/media/image4pro3.6a5962b6.jpeg";